module.exports = __webpack_public_path__ + "static/media/ashares_c.13459beb.png";